import SVG from './SVG'

export const FacebookIconSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <g className="ic_share_facebook">
        <circle cx="20" cy="20" r="20" fill="white" />
        <path
          d="M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 9.982 7.314 18.257 16.875 19.757V25.781h-5.078V20h5.078v-4.406c0-5.013 2.986-7.781 7.554-7.781 2.189 0 4.477.39 4.477.39v4.922h-2.522c-2.484 0-3.259 1.542-3.259 3.123V20h5.547l-.887 5.781h-4.66v13.976C32.686 38.257 40 29.983 40 20Z"
          className="Vector"
        />
      </g>
    </SVG>
  )
}
